import React, { useState } from "react";
import Card from "./Card";

import { useAppStore } from "@store/appStateStore";

import "./DashboardCard.css";
import ParticipantInput from "@components/form/control/participant/select/participantInput";
import { sortParticipantsByName } from "@components/form/utils/sort";

const DashboardCard: React.FC = () => {
  const {
    participant,
    participants,
    transactions,
    attendances,
    setParticipant,
  } = useAppStore();

  const [selectedParticipantId, setSelectedParticipantId] = useState<
    number | null
  >(participant ?? null);

  // Расчет баланса участников
  const calculateBalance = () => {
    const filteredTransactions = selectedParticipantId
      ? transactions.filter((t) => t.participant_id === selectedParticipantId)
      : transactions;

    // Сумма транзакций за период
    const totalTransactions = filteredTransactions.reduce(
      (sum, t) => sum + t.amount,
      0,
    );

    // Фильтрация посещений по участнику и периоду
    const filteredAttendances = selectedParticipantId
      ? attendances.filter((a) => a.participant_id === selectedParticipantId)
      : attendances;

    // Сумма посещений за период
    const totalAttendances = filteredAttendances.reduce(
      (sum, a) => sum + a.amount,
      0,
    );

    return totalTransactions - totalAttendances;
  };

  // Подсчет посещенных занятий
  const countAttendances = () => {
    const filteredAttendances = selectedParticipantId
      ? attendances.filter((a) => a.participant_id === selectedParticipantId)
      : attendances;

    return filteredAttendances.length;
  };

  const balance = calculateBalance();
  const attendanceCount = countAttendances();

  return (
    <Card title="Дашборд участника">
      <div className="dashboard-content">
        <div className="participant-selector">
          <label htmlFor="participant-select" className="control">
            Выберите участника:
          </label>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <ParticipantInput
              id="participantSelect"
              onChange={(e: any) => {
                setSelectedParticipantId(e);
                setParticipant(e);
              }}
              required={true}
              value={selectedParticipantId ?? 0}
              options={sortParticipantsByName(participants)}
            />
            <button
              style={{ marginLeft: "1rem", width: 40 }}
              type="button"
              className="control"
              disabled={!selectedParticipantId}
              onClick={() => {
                setSelectedParticipantId(0);
                setParticipant(null);

                setParticipant(null);
              }}
            >
              {"X"}
            </button>
          </div>
        </div>

        <div className="dashboard-stats">
          <div className="stat-item">
            <h4>Баланс</h4>
            <p
              className={`balance-amount ${balance >= 0 ? "positive" : "negative"}`}
            >
              {balance} р.
            </p>
          </div>
          <div className="stat-item">
            <h4>Посещено занятий</h4>
            <p className="attendance-count">
              {attendanceCount !== null ? attendanceCount : 0}
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DashboardCard;
